import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
const User_panel = () => {
  const user = useSelector((state) => state.AuthReducer.user);
  const isAuth = useSelector((state) => state.AuthReducer.isAuth);
  const lang = useSelector((state) => state.HelperReducer.lang);
  return (
    <div
      className="main-header-left d-none d-lg-block"
      style={{ borderTop: "1px solid #f1f3fe" }}
    >
      <div className="logo-wrapper justify-content-center mt-1">
        {lang !== "en" ? (
          <div className="row">
            <div className="col-1"></div>
            <div className="col-7 d-flex justify-content-end">
              <Link to={`/dashboard`}>
                <i
                  style={{
                    color: "grey",
                    fontSize: "14px",
                  }}
                >
                  Welcome
                </i>

                <br />
                <i
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                >
                  {isAuth !== null ? `${user.fname}   ${user.lname}` : ""}
                </i>
              </Link>
            </div>
            <div className="col-3 d-flex justify-content-start">
              {" "}
              <img
                className=""
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100%",
                }}
                src={`https://e7.pngegg.com/pngimages/613/636/png-clipart-computer-icons-user-profile-male-avatar-avatar-heroes-logo-thumbnail.png`}
                alt=""
              />
            </div>
          </div>
        ) : (
          <div className="row ">
            <div className="col-4 d-flex justify-content-end">
              {" "}
              <img
                className=""
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100%",
                }}
                src={`https://e7.pngegg.com/pngimages/613/636/png-clipart-computer-icons-user-profile-male-avatar-avatar-heroes-logo-thumbnail.png`}
                alt=""
              />
            </div>
            <div className="col-7 d-flex justify-content-center">
              <Link to={`/dashboard`}>
                <i
                  style={{
                    color: "grey",
                    fontSize: "14px",
                  }}
                >
                  Welcome
                </i>

                <br />
                <i
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                >
                  {isAuth !== null ? `${user.fname}   ${user.lname}` : ""}
                </i>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default User_panel;
